/* eslint-disable */
// source: vivacity/core/authorization.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var vivacity_core_authentication_pb = require('../../vivacity/core/authentication_pb.js');
goog.object.extend(proto, vivacity_core_authentication_pb);
goog.exportSymbol('proto.vivacity.core.AuthorizationMessage', null, global);
goog.exportSymbol('proto.vivacity.core.AuthorizationMessage.Type', null, global);
goog.exportSymbol('proto.vivacity.core.AuthorizationRequest', null, global);
goog.exportSymbol('proto.vivacity.core.AuthorizationRequest.Type', null, global);
goog.exportSymbol('proto.vivacity.core.AuthorizationRequestEntity', null, global);
goog.exportSymbol('proto.vivacity.core.AuthorizationResponse', null, global);
goog.exportSymbol('proto.vivacity.core.GetAllAuthorizedObjectsConfig', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AuthorizationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.AuthorizationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AuthorizationMessage.displayName = 'proto.vivacity.core.AuthorizationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AuthorizationRequestEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.AuthorizationRequestEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AuthorizationRequestEntity.displayName = 'proto.vivacity.core.AuthorizationRequestEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AuthorizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.AuthorizationRequest.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.AuthorizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AuthorizationRequest.displayName = 'proto.vivacity.core.AuthorizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.GetAllAuthorizedObjectsConfig.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.GetAllAuthorizedObjectsConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.GetAllAuthorizedObjectsConfig.displayName = 'proto.vivacity.core.GetAllAuthorizedObjectsConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AuthorizationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.AuthorizationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AuthorizationResponse.displayName = 'proto.vivacity.core.AuthorizationResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AuthorizationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AuthorizationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AuthorizationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    request: (f = msg.getRequest()) && proto.vivacity.core.AuthorizationRequest.toObject(includeInstance, f),
    response: (f = msg.getResponse()) && proto.vivacity.core.AuthorizationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AuthorizationMessage}
 */
proto.vivacity.core.AuthorizationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AuthorizationMessage;
  return proto.vivacity.core.AuthorizationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AuthorizationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AuthorizationMessage}
 */
proto.vivacity.core.AuthorizationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vivacity.core.AuthorizationMessage.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.vivacity.core.AuthorizationRequest;
      reader.readMessage(value,proto.vivacity.core.AuthorizationRequest.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 3:
      var value = new proto.vivacity.core.AuthorizationResponse;
      reader.readMessage(value,proto.vivacity.core.AuthorizationResponse.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AuthorizationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AuthorizationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AuthorizationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vivacity.core.AuthorizationRequest.serializeBinaryToWriter
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vivacity.core.AuthorizationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.vivacity.core.AuthorizationMessage.Type = {
  REQUEST: 0,
  RESPONSE: 1
};

/**
 * optional Type type = 1;
 * @return {!proto.vivacity.core.AuthorizationMessage.Type}
 */
proto.vivacity.core.AuthorizationMessage.prototype.getType = function() {
  return /** @type {!proto.vivacity.core.AuthorizationMessage.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vivacity.core.AuthorizationMessage.Type} value
 * @return {!proto.vivacity.core.AuthorizationMessage} returns this
 */
proto.vivacity.core.AuthorizationMessage.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional AuthorizationRequest request = 2;
 * @return {?proto.vivacity.core.AuthorizationRequest}
 */
proto.vivacity.core.AuthorizationMessage.prototype.getRequest = function() {
  return /** @type{?proto.vivacity.core.AuthorizationRequest} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.AuthorizationRequest, 2));
};


/**
 * @param {?proto.vivacity.core.AuthorizationRequest|undefined} value
 * @return {!proto.vivacity.core.AuthorizationMessage} returns this
*/
proto.vivacity.core.AuthorizationMessage.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AuthorizationMessage} returns this
 */
proto.vivacity.core.AuthorizationMessage.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AuthorizationMessage.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AuthorizationResponse response = 3;
 * @return {?proto.vivacity.core.AuthorizationResponse}
 */
proto.vivacity.core.AuthorizationMessage.prototype.getResponse = function() {
  return /** @type{?proto.vivacity.core.AuthorizationResponse} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.AuthorizationResponse, 3));
};


/**
 * @param {?proto.vivacity.core.AuthorizationResponse|undefined} value
 * @return {!proto.vivacity.core.AuthorizationMessage} returns this
*/
proto.vivacity.core.AuthorizationMessage.prototype.setResponse = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AuthorizationMessage} returns this
 */
proto.vivacity.core.AuthorizationMessage.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AuthorizationMessage.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AuthorizationRequestEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AuthorizationRequestEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationRequestEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    entityType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    privilegeGrant: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requestingPrincipal: jspb.Message.getFieldWithDefault(msg, 4, ""),
    feature: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AuthorizationRequestEntity}
 */
proto.vivacity.core.AuthorizationRequestEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AuthorizationRequestEntity;
  return proto.vivacity.core.AuthorizationRequestEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AuthorizationRequestEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AuthorizationRequestEntity}
 */
proto.vivacity.core.AuthorizationRequestEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivilegeGrant(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingPrincipal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AuthorizationRequestEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AuthorizationRequestEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationRequestEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEntityType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrivilegeGrant();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestingPrincipal();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFeature();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string entity_id = 1;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.getEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequestEntity} returns this
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.setEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string entity_type = 2;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.getEntityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequestEntity} returns this
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.setEntityType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string privilege_grant = 3;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.getPrivilegeGrant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequestEntity} returns this
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.setPrivilegeGrant = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requesting_principal = 4;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.getRequestingPrincipal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequestEntity} returns this
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.setRequestingPrincipal = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string feature = 5;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.getFeature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequestEntity} returns this
 */
proto.vivacity.core.AuthorizationRequestEntity.prototype.setFeature = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.AuthorizationRequest.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AuthorizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AuthorizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AuthorizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    entityType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    privilegeGrant: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requestingPrincipal: jspb.Message.getFieldWithDefault(msg, 4, ""),
    token: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clientCertificateChain: jspb.Message.getFieldWithDefault(msg, 6, ""),
    requestId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    extraEntitiesList: jspb.Message.toObjectList(msg.getExtraEntitiesList(),
    proto.vivacity.core.AuthorizationRequestEntity.toObject, includeInstance),
    entitiesList: jspb.Message.toObjectList(msg.getEntitiesList(),
    proto.vivacity.core.AuthorizationRequestEntity.toObject, includeInstance),
    method: jspb.Message.getFieldWithDefault(msg, 10, 0),
    type: jspb.Message.getFieldWithDefault(msg, 11, 0),
    getAllAuthorizedObjectsConfig: (f = msg.getGetAllAuthorizedObjectsConfig()) && proto.vivacity.core.GetAllAuthorizedObjectsConfig.toObject(includeInstance, f),
    sourcePlatform: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AuthorizationRequest}
 */
proto.vivacity.core.AuthorizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AuthorizationRequest;
  return proto.vivacity.core.AuthorizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AuthorizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AuthorizationRequest}
 */
proto.vivacity.core.AuthorizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivilegeGrant(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingPrincipal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientCertificateChain(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequestId(value);
      break;
    case 8:
      var value = new proto.vivacity.core.AuthorizationRequestEntity;
      reader.readMessage(value,proto.vivacity.core.AuthorizationRequestEntity.deserializeBinaryFromReader);
      msg.addExtraEntities(value);
      break;
    case 9:
      var value = new proto.vivacity.core.AuthorizationRequestEntity;
      reader.readMessage(value,proto.vivacity.core.AuthorizationRequestEntity.deserializeBinaryFromReader);
      msg.addEntities(value);
      break;
    case 10:
      var value = /** @type {!proto.vivacity.core.AuthMethod} */ (reader.readEnum());
      msg.setMethod(value);
      break;
    case 11:
      var value = /** @type {!proto.vivacity.core.AuthorizationRequest.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 12:
      var value = new proto.vivacity.core.GetAllAuthorizedObjectsConfig;
      reader.readMessage(value,proto.vivacity.core.GetAllAuthorizedObjectsConfig.deserializeBinaryFromReader);
      msg.setGetAllAuthorizedObjectsConfig(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourcePlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AuthorizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AuthorizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AuthorizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEntityType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrivilegeGrant();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestingPrincipal();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClientCertificateChain();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getExtraEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.vivacity.core.AuthorizationRequestEntity.serializeBinaryToWriter
    );
  }
  f = message.getEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.vivacity.core.AuthorizationRequestEntity.serializeBinaryToWriter
    );
  }
  f = message.getMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getGetAllAuthorizedObjectsConfig();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.vivacity.core.GetAllAuthorizedObjectsConfig.serializeBinaryToWriter
    );
  }
  f = message.getSourcePlatform();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.vivacity.core.AuthorizationRequest.Type = {
  AUTHORIZE_REQUESTED_ENTITIES: 0,
  GET_ALL_AUTHORIZED_OBJECTS: 1
};

/**
 * optional string entity_id = 1;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string entity_type = 2;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getEntityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setEntityType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string privilege_grant = 3;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getPrivilegeGrant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setPrivilegeGrant = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requesting_principal = 4;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getRequestingPrincipal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setRequestingPrincipal = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string token = 5;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string client_certificate_chain = 6;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getClientCertificateChain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setClientCertificateChain = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 request_id = 7;
 * @return {number}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated AuthorizationRequestEntity extra_entities = 8;
 * @return {!Array<!proto.vivacity.core.AuthorizationRequestEntity>}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getExtraEntitiesList = function() {
  return /** @type{!Array<!proto.vivacity.core.AuthorizationRequestEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.core.AuthorizationRequestEntity, 8));
};


/**
 * @param {!Array<!proto.vivacity.core.AuthorizationRequestEntity>} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
*/
proto.vivacity.core.AuthorizationRequest.prototype.setExtraEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.vivacity.core.AuthorizationRequestEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.AuthorizationRequestEntity}
 */
proto.vivacity.core.AuthorizationRequest.prototype.addExtraEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.vivacity.core.AuthorizationRequestEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.clearExtraEntitiesList = function() {
  return this.setExtraEntitiesList([]);
};


/**
 * repeated AuthorizationRequestEntity entities = 9;
 * @return {!Array<!proto.vivacity.core.AuthorizationRequestEntity>}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getEntitiesList = function() {
  return /** @type{!Array<!proto.vivacity.core.AuthorizationRequestEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.core.AuthorizationRequestEntity, 9));
};


/**
 * @param {!Array<!proto.vivacity.core.AuthorizationRequestEntity>} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
*/
proto.vivacity.core.AuthorizationRequest.prototype.setEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.vivacity.core.AuthorizationRequestEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.AuthorizationRequestEntity}
 */
proto.vivacity.core.AuthorizationRequest.prototype.addEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.vivacity.core.AuthorizationRequestEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.clearEntitiesList = function() {
  return this.setEntitiesList([]);
};


/**
 * optional AuthMethod method = 10;
 * @return {!proto.vivacity.core.AuthMethod}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getMethod = function() {
  return /** @type {!proto.vivacity.core.AuthMethod} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.vivacity.core.AuthMethod} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional Type type = 11;
 * @return {!proto.vivacity.core.AuthorizationRequest.Type}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getType = function() {
  return /** @type {!proto.vivacity.core.AuthorizationRequest.Type} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.vivacity.core.AuthorizationRequest.Type} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional GetAllAuthorizedObjectsConfig get_all_authorized_objects_config = 12;
 * @return {?proto.vivacity.core.GetAllAuthorizedObjectsConfig}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getGetAllAuthorizedObjectsConfig = function() {
  return /** @type{?proto.vivacity.core.GetAllAuthorizedObjectsConfig} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.GetAllAuthorizedObjectsConfig, 12));
};


/**
 * @param {?proto.vivacity.core.GetAllAuthorizedObjectsConfig|undefined} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
*/
proto.vivacity.core.AuthorizationRequest.prototype.setGetAllAuthorizedObjectsConfig = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.clearGetAllAuthorizedObjectsConfig = function() {
  return this.setGetAllAuthorizedObjectsConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.AuthorizationRequest.prototype.hasGetAllAuthorizedObjectsConfig = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string source_platform = 13;
 * @return {string}
 */
proto.vivacity.core.AuthorizationRequest.prototype.getSourcePlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationRequest} returns this
 */
proto.vivacity.core.AuthorizationRequest.prototype.setSourcePlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.GetAllAuthorizedObjectsConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    rootEntityType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    edgeEntityType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    privilegeGrant: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requestingPrincipal: jspb.Message.getFieldWithDefault(msg, 4, ""),
    projectIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.GetAllAuthorizedObjectsConfig;
  return proto.vivacity.core.GetAllAuthorizedObjectsConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootEntityType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEdgeEntityType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivilegeGrant(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingPrincipal(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addProjectIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.GetAllAuthorizedObjectsConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRootEntityType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEdgeEntityType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrivilegeGrant();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestingPrincipal();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProjectIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      5,
      f
    );
  }
};


/**
 * optional string root_entity_type = 1;
 * @return {string}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.getRootEntityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.setRootEntityType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string edge_entity_type = 2;
 * @return {string}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.getEdgeEntityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.setEdgeEntityType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string privilege_grant = 3;
 * @return {string}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.getPrivilegeGrant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.setPrivilegeGrant = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requesting_principal = 4;
 * @return {string}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.getRequestingPrincipal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.setRequestingPrincipal = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated int32 project_ids = 5;
 * @return {!Array<number>}
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.getProjectIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.setProjectIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.addProjectIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.GetAllAuthorizedObjectsConfig} returns this
 */
proto.vivacity.core.GetAllAuthorizedObjectsConfig.prototype.clearProjectIdsList = function() {
  return this.setProjectIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AuthorizationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AuthorizationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AuthorizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    granted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    rejectionReason: jspb.Message.getFieldWithDefault(msg, 2, ""),
    canAccessAllEntities: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isImpersonatingUser: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    impersonatedUserUuid: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AuthorizationResponse}
 */
proto.vivacity.core.AuthorizationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AuthorizationResponse;
  return proto.vivacity.core.AuthorizationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AuthorizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AuthorizationResponse}
 */
proto.vivacity.core.AuthorizationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGranted(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRejectionReason(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanAccessAllEntities(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsImpersonatingUser(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImpersonatedUserUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AuthorizationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AuthorizationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AuthorizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AuthorizationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGranted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCanAccessAllEntities();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsImpersonatingUser();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getImpersonatedUserUuid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional bool granted = 1;
 * @return {boolean}
 */
proto.vivacity.core.AuthorizationResponse.prototype.getGranted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.AuthorizationResponse} returns this
 */
proto.vivacity.core.AuthorizationResponse.prototype.setGranted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string rejection_reason = 2;
 * @return {string}
 */
proto.vivacity.core.AuthorizationResponse.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationResponse} returns this
 */
proto.vivacity.core.AuthorizationResponse.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool can_access_all_entities = 3;
 * @return {boolean}
 */
proto.vivacity.core.AuthorizationResponse.prototype.getCanAccessAllEntities = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.AuthorizationResponse} returns this
 */
proto.vivacity.core.AuthorizationResponse.prototype.setCanAccessAllEntities = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_impersonating_user = 4;
 * @return {boolean}
 */
proto.vivacity.core.AuthorizationResponse.prototype.getIsImpersonatingUser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.AuthorizationResponse} returns this
 */
proto.vivacity.core.AuthorizationResponse.prototype.setIsImpersonatingUser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string impersonated_user_uuid = 5;
 * @return {string}
 */
proto.vivacity.core.AuthorizationResponse.prototype.getImpersonatedUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AuthorizationResponse} returns this
 */
proto.vivacity.core.AuthorizationResponse.prototype.setImpersonatedUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


goog.object.extend(exports, proto.vivacity.core);
